<script>
  import fileTemplateState from "../../stores/fileTemplateJsonData"
  import ApplicationState from "../../../../../Stores/applicationStates"
  import axios from "axios"
  import notify from "../../../../../Script/notify"
  import { push, querystring } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../../../Script/queryString"
  import { flatenObject } from "../../../../../Script/flatenObject"
  import { checkMaxCharacters, trimSpacesTemplateName } from "../Script/tempNamevalidation"
  import ChangeCertificate from "../modules/changeCertificate/index.svelte"
  import { patchRequest } from "../../../../../Script/apiMethods"

  /**
   * @type {String} -  Represents a query string or search parameter.
   */
  let query
  /**
   * @type {Boolean} - To hide and show image quality of the range value
   */
  let setting = false
  /**
   * @type {Boolean} - To hide and show the base image change modal
   */
  let chooseCertificate
  /**
   * @type {Boolean} - Indicating whether the save button should be disabled or not
   */
  let disableSaveBtn = false
  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {closeNotification}
   */
  let closeNotification = {
    close() {},
  }

  // save the file template for particular id
  /**
   * Saves the overall file template by sending a PATCH request to the server.
   * Performs validation checks, converts the query string to a JSON object,
   * and updates the file template information.
   *
   * @throws {string} Throws an error if the file template name is empty.
   */
  const overAllTempSave = async () => {
    // Validation check for empty file template name
    try {
      if (!$fileTemplateState.baseImageInfo.name.trim()) throw "File template name can't be empty"
      $fileTemplateState.operations = $fileTemplateState.operations.map((opp) => {
        if (opp.errorX || opp.errorY) throw `Fix the layers marked with Exclamation icon as they are out of bounds.`
        // if (opp.errorX || opp.errorY) throw "Fix the layer position as it is out of boundary."
        return opp
      })
      if (!$fileTemplateState.operations.length) throw "Please add at least one layer."

      let isReceiverNameFound = Boolean($fileTemplateState.operations.filter((item) => item.attribute == "receiver_name").length)

      if (!isReceiverNameFound) throw 'The layer named "receiver_name" is missing, and it is mandatory. Please add the "receiver_name" layer'

      disableSaveBtn = true // Disable the save button

      await loadFontList() // Call the loadFontList function asynchronously
      // Convert query string to JSON object

      // Flatten the parsedJson object to create underscored metadata keys
      let flatObject = flatenObject($fileTemplateState.parsedJson)

      for (let i = 0; i < $fileTemplateState.operations.length; i++) {
        if ($fileTemplateState.operations[i].type == "image") {
          if ($fileTemplateState.operations[i].dynamic) {
            $fileTemplateState.operations[i].src = ""
          } else {
            if (!$fileTemplateState.operations[i].src.startsWith("/ipfs/")) $fileTemplateState.operations[i].src = ""
          }
        }
        if ($fileTemplateState.operations[i].type == "text") {
          if (flatObject[$fileTemplateState.operations[i].attribute]) {
            $fileTemplateState.operations[i].value = flatObject[$fileTemplateState.operations[i].attribute]
          } else {
            if ($fileTemplateState.operations[i].value == "Enter your text") {
              $fileTemplateState.operations[i].value = ""
            }
          }
        }
        // if ($fileTemplateState.operations[i].type == "text") {
        //   if (flatObject[$fileTemplateState.operations[i].attribute] != undefined || $fileTemplateState.operations[i].value == "Text") {
        //     $fileTemplateState.operations[i].value = ""
        //   }
        // }
      }

      let updatedFileTemp = {
        document: $fileTemplateState.documentTemplateId,
        fonts: JSON.stringify($fileTemplateState.fonts),
        layers: JSON.stringify($fileTemplateState.operations),
        name: $fileTemplateState.baseImageInfo.name,
        quality: $fileTemplateState.baseImageInfo.Quality,
      }

      if ($fileTemplateState.baseImageInfo.uri.startsWith("blob")) {
        const { data } = await axios.get($fileTemplateState.baseImageInfo.uri, { responseType: "blob" })
        // console.log(data, "blobData")

        const file = new File([data], $fileTemplateState.baseImageInfo.name, {
          type: data.type,
        })

        updatedFileTemp.file = file
        updatedFileTemp.palette = JSON.stringify($fileTemplateState.baseImageInfo.palette)
      }

      query = queryStringToJSON($querystring)

      // Save file template
      const { template } = await patchRequest(`/api/swagger/v2/templates/files/${$fileTemplateState.baseImageInfo.id}`, updatedFileTemp, {
        headers: {
          "x-access-token": $ApplicationState.token,
          "Content-Type": "multipart/form-data",
        },
      })

      notify.success(`File Design Template <strong style="hyphens: auto;">${template.name}</strong> saved successfully`) // Show a success notification

      push("/templates/file") // Redirect to the file templates page

      goInitialState() // Call the goInitialState function
    } catch (error) {
      closeNotification.close()
      const info = "PAGE: File template Editor\nEVENT: While updating file template"
      closeNotification = notify.danger(error, info)
    } finally {
      disableSaveBtn = false // Redirect to the file templates page
    }
  }
  /**
   * Loads the list of fonts by sending a GET request to the server.
   * Updates the font list in the file template state.
   */
  const loadFontList = () => {
    return new Promise(async (resolve, reject) => {
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        const { data } = await axios.get("/api/swagger/v2/fonts", {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        })
        // Error checking while API call
        if (data.error && !data.success) {
          throw data.errorCode
        }

        let fontList = [...data.fonts]

        $fileTemplateState.fonts = []

        for (let i = 0; i < $fileTemplateState.operations.length; i++) {
          if ($fileTemplateState.operations[i].type == "text") {
            for (let j = 0; j < fontList.length; j++) {
              if (fontList[j].name == $fileTemplateState.operations[i].fontFamily) {
                $fileTemplateState.fonts = [...$fileTemplateState.fonts, fontList[j].id]
              }
            }
          }
        }
        $fileTemplateState.fonts = [...new Set($fileTemplateState.fonts)]

        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  /**
   * Resets the $fileTemplateState object to its initial state.
   */
  const goInitialState = () => {
    $fileTemplateState = {
      documentTemplateId: undefined,
      documentTempName: "None",
      baseImageUploadModal: false,
      runWatcher: false,
      baseImageInfo: {},
      fonts: [],
      activeFontFamily: "Arial",
      operations: [],
      tempOperation: [],
      download: false,
      canvasScale: 0,
      canvasHeight: 0,
      parsedJson: {},
      templateDel: false,
      apiFonts: [],
      goBack: false,
      showImageSection: false,
      footerArray: ["You can change the quality in settings", "Add or Edit, Text, Image and qr elements", "You can Add custom fonts for text layers", "You can Able to change File template name", "Able to Download the canvas"],
    }
    localStorage.setItem("P2BFileTempEditor", JSON.stringify($fileTemplateState))
    // ($fileTemplateState)
  }
  /**
   * @description Function for Converting the range value
   */
  const changeRange = (e) => {
    if (e.target.value > 100) $fileTemplateState.baseImageInfo.rangeValue = 100
    if (e.target.value < 0) $fileTemplateState.baseImageInfo.rangeValue = 0
    if (e.target.type == "number" && e.target.value >= 0 && e.target.value <= 100) $fileTemplateState.baseImageInfo.rangeValue = e.target.value
    // $fileTemplateState.baseImageInfo.Quality = Math.min(1, Math.max(0, Math.round(((15.76935 * $fileTemplateState.baseImageInfo.rangeValue) / 10 / (5.513167 + $fileTemplateState.baseImageInfo.rangeValue / 10)) * 100) / 1000))
    $fileTemplateState.baseImageInfo.Quality = $fileTemplateState.baseImageInfo.rangeValue / 100
  }

  /**
   * @type {invalidNotification}
   */
  let invalidNotification = {
    close() {},
  }

  /**
   * Regular expression pattern for allowed characters.
   * Matches any combination of uppercase letters, lowercase letters, digits, spaces, hyphens, parentheses, plus signs, ampersands, and periods.
   * @type {RegExp}
   */
  const allowedCharsRegex = /^[A-Z\d\s-()+&.]*$/i

  const checkSpecialChars = (e) => {
    // Close any existing notifications
    const info = "PAGE: File Template Editor\nEVENT: Validating invalid characters for the file template name during onBlur/ onPaste/ onKeypress"

    // Destructure the type and key properties from the event object
    let { type, key } = e

    // Check if it's a keypress event and the pressed key is not allowed

    if (type === "keypress" && !allowedCharsRegex.test(key)) {
      invalidNotification.close()

      // Prevent the default keypress behavior if the pressed key is not allowed
      e.preventDefault()

      $fileTemplateState.baseImageInfo.name += key

      // Show a danger notification indicating the allowed characters
      invalidNotification = notify.danger("Only <strong>Letters</strong>,<strong>Numbers</strong> and <strong>-()+.&</strong> are allowed.", info)

      setTimeout(() => {
        // Remove the last invalid character
        $fileTemplateState.baseImageInfo.name = $fileTemplateState.baseImageInfo.name.slice(0, -1)
      }, 100)
    } else if (type === "paste" || type === "blur") {
      invalidNotification.close()

      // Prevent the default paste behavior
      // e.preventDefault()

      let pastedText

      if (type === "blur") {
        pastedText = $fileTemplateState.baseImageInfo.name
      } else {
        // Get the pasted text from the clipboard
        let clipboardData = e.clipboardData || window.clipboardData
        pastedText = clipboardData.getData("text/plain")
      }

      // Set the input value to the pasted text
      // name = pastedText

      setTimeout(() => {
        // Remove any characters that are not letters, spaces, or specified special characters
        // let sanitizedText = pastedText.replace(new RegExp(`[^A-Z_\\-\\s\\d()+₹.]`, "gi"), "").trim()
        // Set the input value to the sanitized text
        // name = checkMaxCharacters(name)
        // Show a danger notification indicating the allowed characters and the removed non-specified characters

        if (!allowedCharsRegex.test(pastedText)) {
          let sanitizedText = pastedText.replace(/[^A-Za-z0-9\s-()+&.]/g, "").trim()
          if (sanitizedText !== pastedText) {
            invalidNotification = notify.danger("Only <strong>Letters</strong>,<strong>Numbers</strong> and <strong>-()+.&</strong> are allowed. Removing non-specified Characters", info)
          }
          $fileTemplateState.baseImageInfo.name = sanitizedText
        }

        $fileTemplateState.baseImageInfo.name = checkMaxCharacters($fileTemplateState.baseImageInfo.name)
        // $fileTemplateState.baseImageInfo.name = name
      }, 500)
    }
  }
</script>

<!-- svelte-ignore a11y-mouse-events-have-key-events -->

<div class="flex w-[397px] flex-col justify-center gap-3 rounded-md bg-[#292A2F] p-6">
  <div class="space-y-3">
    <div class="flex w-full justify-end gap-3">
      <button
        on:click={() => {
          $fileTemplateState.templateDel = true
        }}
        class="active:bg-red-g00 group flex h-9 w-1/3 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-red-500 px-2 text-sm font-medium text-white hover:bg-red-600 focus:outline-none"
      >
        <span class="text-white">
          <i class="fa-solid fa-trash-can" />
        </span>
        <span class="select-none">&nbsp;&nbsp;Delete</span>
      </button>
      <button on:click={() => (setting = !setting)} class="active:bg-red-g00 group flex h-9 w-1/3 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none">
        <span class="text-white">
          <i class="fa-solid fa-gear" />
        </span>
        <span class="select-none">&nbsp;&nbsp;Settings</span>
      </button>

      <button disabled={disableSaveBtn} on:click={overAllTempSave} class="active:bg-green-g00 group flex h-9 w-1/3 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-green-500 px-2 text-sm font-medium text-white hover:bg-green-600 focus:outline-none disabled:cursor-not-allowed disabled:opacity-30">
        <span class="text-white">
          <i class="fa-solid fa-floppy-disk" />
        </span>
        <span class="select-none">&nbsp;&nbsp;Save</span>
      </button>
    </div>
    {#if !setting}
      <div class="flex flex-col gap-3">
        <span class="text-white">Quality to download file.</span>
        <div class="flex flex-col items-center gap-3">
          <!-- <div class="w-12 rounded-md border border-[#a0a1a580] px-2 py-0.5 text-xs text-white">
            {Math.floor($fileTemplateState.baseImageInfo.Quality * 1000) / 10}
          </div> -->

          <div class="flex w-full items-center gap-3 text-gray-g00">
            <input on:input={changeRange} min="0" max="100" bind:value={$fileTemplateState.baseImageInfo.rangeValue} type="number" class="w-12 rounded-md border border-stone-700 bg-transparent py-2 pl-2 pr-1 text-sm text-white outline-none focus:ring-2 focus:ring-extraBlue-500 peer-focus:ring-2 peer-focus:ring-extraBlue-500" />
            <input
              on:wheel|preventDefault|stopPropagation={(e) => {
                if (e.deltaY < 0) {
                  if ($fileTemplateState.baseImageInfo.rangeValue < 100) {
                    $fileTemplateState.baseImageInfo.rangeValue += 1
                    // $fileTemplateState.baseImageInfo.Quality = Math.min(1, Math.max(0, Math.round(((15.76935 * $fileTemplateState.baseImageInfo.rangeValue) / 10 / (5.513167 + $fileTemplateState.baseImageInfo.rangeValue / 10)) * 100) / 1000))
                    $fileTemplateState.baseImageInfo.Quality = $fileTemplateState.baseImageInfo.rangeValue / 100
                  }
                } else {
                  if ($fileTemplateState.baseImageInfo.rangeValue > 0) {
                    $fileTemplateState.baseImageInfo.rangeValue -= 1
                    // $fileTemplateState.baseImageInfo.Quality = Math.min(1, Math.max(0, Math.round(((15.76935 * $fileTemplateState.baseImageInfo.rangeValue) / 10 / (5.513167 + $fileTemplateState.baseImageInfo.rangeValue / 10)) * 100) / 1000))
                    $fileTemplateState.baseImageInfo.Quality = $fileTemplateState.baseImageInfo.rangeValue / 100
                  }
                }
              }}
              bind:value={$fileTemplateState.baseImageInfo.rangeValue}
              title={Math.floor($fileTemplateState.baseImageInfo.Quality * 1000) / 10}
              step="1"
              on:input={changeRange}
              min="1"
              max="100"
              type="range"
              class="h-1 w-full cursor-pointer"
            />
          </div>
        </div>
      </div>
      <div class="group relative w-full rounded-md">
        <div class="absolute left-3 top-2.5 select-none text-sm font-bold text-gray-g00 {$fileTemplateState.baseImageInfo.name ? 'group-focus-within:text-extraBlue-500' : 'group-focus-within:text-red-500'}">NAME</div>
        <div class="group relative mt-1 flex w-full items-center justify-between text-white">
          <input
            on:blur={() => {
              $fileTemplateState.baseImageInfo.name = trimSpacesTemplateName($fileTemplateState.baseImageInfo.name)
            }}
            on:blur={checkSpecialChars}
            on:paste={checkSpecialChars}
            on:keypress={checkSpecialChars}
            on:keypress={() => {
              $fileTemplateState.baseImageInfo.name = checkMaxCharacters($fileTemplateState.baseImageInfo.name)
            }}
            bind:value={$fileTemplateState.baseImageInfo.name}
            type="text"
            required
            placeholder="Enter Template name"
            class="w-full rounded-md border border-stone-700 bg-transparent py-2 pl-16 pr-10 text-sm text-white outline-none invalid:animate-shake focus:ring-2 focus:ring-extraBlue-500 invalid:focus:ring-red-500"
          />
        </div>
        <button
          on:click={() => {
            closeNotification.close()
            // $fileTemplateState.operations = $fileTemplateState.operations.map((opp) => {
            //   if (opp.errorX || opp.errorY) throw "Fix the layer position as it is out of boundary."
            //   return opp
            // })
            chooseCertificate = true
            closeNotification = notify.warning("If you change the Image File, the previous changes will be replaced.")
          }}
          class="group mt-3 flex h-9 w-full cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-sky-500 px-6 text-sm font-medium text-white hover:bg-sky-600 focus:outline-none"
        >
          <span class="text-white">
            <i class="fa-solid fa-rotate" />
          </span>
          <span class="select-none">&nbsp;&nbsp;Change Image File</span>
        </button>
        <!-- <input readonly value={$DocumentCarousel.template.name} type="text" class="pointer-events-none w-full truncate rounded-md border border-[#a0a1a580] bg-transparent px-3 py-2 text-left text-white placeholder-gray-200 shadow-sm focus:outline-none sm:text-sm" /> -->
      </div>
    {/if}
  </div>
</div>

{#if chooseCertificate}
  <ChangeCertificate
    bind:chooseCertificate
    on:click={() => {
      chooseCertificate = false
    }}
  />
{/if}
